import { render, staticRenderFns } from "./PaymentCheck.vue?vue&type=template&id=27c36d74&"
import script from "./PaymentCheck.vue?vue&type=script&lang=js&"
export * from "./PaymentCheck.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports